import React from "react";
import "../css/shop.scss";
import { Link } from "react-router-dom";
import productData from "../Datas/productData";

function Shop() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={i < rating ? "star filled" : "star"}>
          ★
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="shop main">
      <div className="shop-header">
        <div className="product-count">{productData.length} products</div>
        
      </div>
      <div className="products-grid">
        {productData.map((product) => (
          <Link to={`/shopDetails/${product.id}`} key={product.id} className="product-card" onClick={toTop}>
            <div className="product-image-container">
              <img src={product.image} alt={product.name} className="product-image" />
            </div>
            <div className="product-info">
              <h3 className="product-name">{product.name}</h3>
              <div className="product-rating">
                {renderStars(product.rating)}
                <span className="review-count">({product.reviews})</span>
              </div>
              <p className="product-price">${product.price}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default Shop;
